<template>
    <ns-loader
        class="ns-loader"
        :toLoad="toLoad"
        @dataFetched="onDataFetched"
    >
        <div slot="content">
            <div class="downloadButton">
                <el-button v-if="status === 'COMPLETED'" class="whiteButton" @click="downloadDocxReport">
                    <svg-button></svg-button>
                    {{getText(`simulation_${docType}_download`)}}
                </el-button>
                <el-button
                    v-else-if="status === 'PENDING' || status === 'RUNNING'"
                    class="whiteButton"
                    v-loading="true"
                >
                    <svg-button></svg-button>
                    {{getText(`simulation_${docType}_generating`)}}
                </el-button>
                <el-button
                    v-else-if="status === 'FAILED'"
                    class="failedButton"
                >
                    {{getText(`simulation_${docType}_failed`)}}
                </el-button>
                <el-button
                    v-else-if="uid === null"
                    class="disabledButton"
                >
                    {{getText(`simulation_${docType}_disabled`)}}
                </el-button>
            </div>
        </div>
    </ns-loader>
</template>

<script>
import axios from 'axios';
import svgButton from './svgButton.vue';
import {mapGetters} from 'vuex';
import moment from 'moment';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2';

export default {

    components: {
        svgButton,
        NsLoader
    },

    props: {
        docType: {
            type: String,
            required: true,
        },
        uid: {
            validator: (value) => {
                return value === null || (typeof value) === "string"
            },
            required: true
        }
    },
    data() {
        return {
            status: '',
            url: ''
        }
    },
    computed: {
        ...mapGetters([
            'getText'
        ]),
        toLoad() {
            if (this.uid === null) {
                return [];
            }
            return [
                {
                    model: 'reports',
                    name: 'report',
                    uid: this.uid
                }
            ]
        }
    },
    methods: {
        onDataFetched(data) {
            if (data.report) {
                this.status = data.report.global_status;
                this.url = data.report.docx_report;
            }
        },
        downloadDocxReport() {
            this.docxLoader = true;
            let url = this.url;
            axios({
                method: 'GET',
                url: url,
                responseType: 'blob'
            }).then((response) => {
                let url = window.URL.createObjectURL(new Blob([response.data]));
                let link = document.createElement('a');
                link.style = 'display: none';
                link.href = url;
                link.download = `${this.getText(this.docType)}-${moment().format('YYYY-MM-DD_HH_mm')}.docx`;
                document.body.appendChild(link); // Required for FF
                link.click(); // This will download the data file named "my_data.csv".
                this.docxLoader = false;
                this.$notify.success({
                    message: this.getText('simulation_report_success')
                });
            }).catch(error => {
                console.error(error);
                this.$notify({
                    type: 'error',
                    message: this.getText('simulation_report_error')
                });
                this.docxLoader = false;
            });
        },
    },
};
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/page/simulation/docxDownloadButton.vue